import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({ width, height, fill }) => (

  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.33332C12.8232 2.33332 12.6536 2.40356 12.5286 2.52858C12.4036 2.65361 12.3333 2.82318 12.3333 2.99999C12.3333 3.1768 12.4036 3.34637 12.5286 3.47139C12.6536 3.59642 12.8232 3.66666 13 3.66666C13.1768 3.66666 13.3464 3.59642 13.4714 3.47139C13.5964 3.34637 13.6667 3.1768 13.6667 2.99999C13.6667 2.82318 13.5964 2.65361 13.4714 2.52858C13.3464 2.40356 13.1768 2.33332 13 2.33332V2.33332ZM10.3333 2.99999C10.3334 2.39021 10.5424 1.79886 10.9255 1.3245C11.3087 0.850137 11.8429 0.521424 12.439 0.393144C13.0351 0.264864 13.6572 0.344768 14.2016 0.619537C14.746 0.894305 15.1797 1.34734 15.4306 1.90314C15.6814 2.45893 15.7342 3.08391 15.5801 3.6739C15.4261 4.2639 15.0745 4.78327 14.5839 5.14546C14.0933 5.50764 13.4934 5.69076 12.8842 5.66429C12.275 5.63782 11.6933 5.40336 11.236 4.99999L5.65866 7.78866C5.66969 7.92933 5.66969 8.07065 5.65866 8.21132L11.236 11C11.7002 10.5907 12.2923 10.3556 12.9108 10.335C13.5293 10.3144 14.1357 10.5095 14.6261 10.887C15.1165 11.2645 15.4604 11.8008 15.5987 12.4039C15.7371 13.0071 15.6614 13.6396 15.3846 14.1931C15.1077 14.7466 14.647 15.1866 14.0813 15.4376C13.5157 15.6886 12.8804 15.7351 12.2842 15.5691C11.688 15.4031 11.1682 15.0349 10.8137 14.5276C10.4592 14.0203 10.2922 13.4056 10.3413 12.7887L4.764 9.99999C4.3791 10.3394 3.90443 10.5606 3.39695 10.637C2.88947 10.7133 2.37074 10.6416 1.903 10.4305C1.43525 10.2193 1.03837 9.87771 0.759974 9.44659C0.481579 9.01547 0.333496 8.51318 0.333496 7.99999C0.333496 7.4868 0.481579 6.9845 0.759974 6.55338C1.03837 6.12227 1.43525 5.78064 1.903 5.56949C2.37074 5.35834 2.88947 5.28665 3.39695 5.36301C3.90443 5.43937 4.3791 5.66054 4.764 5.99999L10.3413 3.21132C10.3359 3.14101 10.3332 3.07051 10.3333 2.99999V2.99999ZM3 7.33332C2.82319 7.33332 2.65362 7.40356 2.52859 7.52858C2.40357 7.65361 2.33333 7.82318 2.33333 7.99999C2.33333 8.1768 2.40357 8.34637 2.52859 8.47139C2.65362 8.59642 2.82319 8.66666 3 8.66666C3.17681 8.66666 3.34638 8.59642 3.4714 8.47139C3.59643 8.34637 3.66666 8.1768 3.66666 7.99999C3.66666 7.82318 3.59643 7.65361 3.4714 7.52858C3.34638 7.40356 3.17681 7.33332 3 7.33332ZM13 12.3333C12.8232 12.3333 12.6536 12.4036 12.5286 12.5286C12.4036 12.6536 12.3333 12.8232 12.3333 13C12.3333 13.1768 12.4036 13.3464 12.5286 13.4714C12.6536 13.5964 12.8232 13.6667 13 13.6667C13.1768 13.6667 13.3464 13.5964 13.4714 13.4714C13.5964 13.3464 13.6667 13.1768 13.6667 13C13.6667 12.8232 13.5964 12.6536 13.4714 12.5286C13.3464 12.4036 13.1768 12.3333 13 12.3333Z"
        fill={fill}
      />
    </g>
  </svg>
);

Svg.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

Svg.defaultProps = {
  width: '16',
  height: '16',
  fill: '#B8238E',
};

export default Svg;
